import { render, staticRenderFns } from "./productedit.vue?vue&type=template&id=5174aaba&scoped=true"
import script from "./productedit.vue?vue&type=script&lang=js"
export * from "./productedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5174aaba",
  null
  
)

export default component.exports